import type { Product, ProductVariant } from "@agapi/mlc-core";
import type { StoreCartItem } from "../stores";

export const productToCartItem = (product: Product, quantity: number = 1, id: string = ''): StoreCartItem => {
  const variant = product.variants[0];
  return {
    ...variantToCartItem(variant, quantity, id),
    id: id, // Will be set from the session data
    name: product.name,
    brand: product.brand.name,
    quantity
  };
}

export const variantToCartItem = (variant: ProductVariant, quantity: number = 1, id: string = ''): StoreCartItem => {
  return {
    id: id, // Will be set from the session data
    sku: variant.sku,
    name: variant.name,
    variantName: variant.name,
    stock: variant.stock,
    brand: variant.brand.name,
    handle: variant.handle,
    brandHandle: variant.brand.handle,
    price: variant.price,
    imageUrl: variant.images[0].url,
    imageAlt: variant.images[0].alt,
    quantity,
  }
}

export const variantToProduct = (variant: ProductVariant): Product => {
  return {
    id: variant.id,
    handle: variant.handle,
    name: variant.name,
    description: variant.description,
    brand: variant.brand,
    categories: variant.categories,
    images: variant.images,
    prices: [variant.price],
    variants: [variant],
    breadcrumbs: variant.breadcrumbs,
    meta: variant.meta,
    relatedBlogPosts: variant.relatedBlogPosts,
    collections: variant.collections
  }
}

export const storyLinkToLink = (link: string) => {
  return link.replace(/^(\/)?(happy-green)?(\/|$)/, '/').replace(/\/$/, '');
}